import { useEffect } from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";

const MatchingCriteria = ({
  questionData,
  handleChange,
  matchingCriteria,
  matchingDescriptions,
  baseQuestion
}) => {
  const handleDisabled = (criteria) => {
    if (
      questionData.questionType === "range" &&
      !["range", "none"].includes(criteria)
    ) {
      return true;
    } else if (
      ["choice","yesno"].includes(questionData.questionType) &&
      !["same", "none"].includes(criteria)
    ) {
      return true;
    } else if (questionData.questionType === "multipleChoice" && !["same", "multiple","none"].includes(criteria)) {
      return true
    } else if (questionData.questionType === "text" && criteria !== 'none') {
      return true
    }
    return false;
  };

  return (
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth>
        <InputLabel>Matching Criteria</InputLabel>
        <Select
          value={questionData.matchingCriteria || ""}
          onChange={(e) => handleChange("matchingCriteria", e.target.value)}
          disabled={baseQuestion}
        >
          <MenuItem value="">Select Matching Criteria</MenuItem>
          {matchingCriteria.map((criteria) => (
            <MenuItem
              key={criteria}
              value={criteria}
              disabled={handleDisabled(criteria)}
            >
              {criteria}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {questionData.matchingCriteria && (
        <Typography variant="caption" color="textSecondary">
          {matchingDescriptions[questionData.matchingCriteria]}
        </Typography>
      )}
    </Grid>
  );
};

export default MatchingCriteria;
